"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ProductTitle = _interopRequireDefault(require("../TitlesAndTexts/ProductTitle"));

var _PublishingServicesAvatar = _interopRequireDefault(require("../ImagesAndIcons/PublishingServicesAvatar"));

var _loginBg = _interopRequireDefault(require("../images/login-bg.jpg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Contents
const MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "LoginLayout__MainWrapper",
  componentId: "design-system__we27pa-0"
})(["display:grid;grid-template-columns:10vw 40vw 50vw;grid-template-rows:30vh 60vh 10vh;grid-template-areas:'. header background' '. main background' '. . background';& > header{display:flex;grid-area:header;align-self:center;}& > main{grid-area:main;}& > aside{grid-area:background;}& div.logo{align-self:center;text-align:center;width:42px;& > svg{display:block;height:28px;margin-left:10px;}}"]);

const ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "LoginLayout__ImageWrapper",
  componentId: "design-system__we27pa-1"
})(["position:absolute;top:0px;right:0px;height:100vh;width:50vw;background-color:transparent;& img{width:100%;height:100%;object-fit:cover;object-position:center center;opacity:1;transition:opacity 500ms ease 0s;}"]);

const LoginLayout = _ref => {
  let {
    productTitle,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(MainWrapper, null, /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/_react.default.createElement(_PublishingServicesAvatar.default, null)), /*#__PURE__*/_react.default.createElement(_ProductTitle.default, null, productTitle)), children, /*#__PURE__*/_react.default.createElement("aside", null, /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _loginBg.default,
    alt: "background"
  }))), /*#__PURE__*/_react.default.createElement("link", {
    href: "https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
    rel: "stylesheet"
  }));
};

LoginLayout.propTypes = {
  productTitle: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired
};
var _default = LoginLayout;
exports.default = _default;